//  *! code , working for upload playlist and rendering videos of that playlist

// import React, { useState } from "react";
// import Modal from "@mui/material/Modal";
// import Fade from "@mui/material/Fade";
// import Typography from "@mui/material/Typography";
// import Backdrop from "@mui/material/Backdrop";
// import Box from "@mui/material/Box";
// import { TextField, Button } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { API } from "../../backend";

// const useStyles = makeStyles(() => ({
//   modal: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 600,
//     maxHeight: "80vh",
//     overflowY: "auto",
//     background: "var(--bg-secondary)",
//     padding: "30px",
//     outline: "none",
//     borderRadius: "10px",
//   },
//   input: {
//     width: "100%",
//     margin: "10px 0",
//   },
//   button: {
//     marginTop: "20px",
//     width: "100%",
//     background: "linear-gradient(92.12deg, #4a1d85 1.79%, #156fbc 99.22%)",
//     color: "#fff",
//   },
//   list: {
//     marginTop: "20px",
//     maxHeight: "250px",
//     overflowY: "scroll",
//   },
//   videoItem: {
//     display: "flex",
//     alignItems: "center",
//     marginBottom: "10px",
//   },
//   thumbnail: {
//     width: "120px",
//     height: "90px",
//     marginRight: "10px",
//   },
//   backBtn: {
//     marginTop: "10px",
//     background: "transparent",
//     color: "var(--text-primary)",
//   },
// }));

// function UploadPlaylistModal({ open, setOpen }) {
//   const classes = useStyles();

//   const [playlistUrl, setPlaylistUrl] = useState("");
//   const [playlistName, setPlaylistName] = useState("");
//   const [playlistDescription, setPlaylistDescription] = useState("");
//   const [videos, setVideos] = useState([]);
//   const [error, setError] = useState("");

//   const handleClose = () => setOpen(false);

//   const handleUploadPlaylist = async () => {
//     if (!playlistUrl || !playlistName) {
//       setError("Please enter playlist URL and name");
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${API}/playlist/create-from-youtube`,
//         {
//           name: playlistName,
//           playlistLink: playlistUrl,
//           description: playlistDescription,
//           // *? add user id later
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${JSON.parse(
//               localStorage.getItem("_access_token"),
//             )}`,
//           },
//         },
//       );
//       console.log(response?.data?.success);

//       if (response?.data?.success === true) {
//         toast("Playlist uploaded successfully!");
//         setVideos(response?.data?.data || []);
//         setPlaylistUrl("");
//         setPlaylistName("");
//         setPlaylistDescription("");
//         setError("");
//       } else {
//         setError("Failed to upload playlist");
//       }
//     } catch (err) {
//       console.log(err);
//       setError("Error uploading playlist");
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <Modal
//         open={open}
//         onClose={handleClose}
//         closeAfterTransition
//         BackdropComponent={Backdrop}
//         BackdropProps={{ timeout: 500 }}
//       >
//         <Fade in={open}>
//           <Box className={classes.modal}>
//             <Typography variant="h6" sx={{ mb: 2 }}>
//               Upload YouTube Playlist
//             </Typography>

//             {error && (
//               <Typography sx={{ color: "red", mb: 1 }}>* {error}</Typography>
//             )}

//             <TextField
//               className={classes.input}
//               label="Playlist Name"
//               value={playlistName}
//               onChange={(e) => setPlaylistName(e.target.value)}
//             />

//             <TextField
//               className={classes.input}
//               label="YouTube Playlist URL"
//               value={playlistUrl}
//               onChange={(e) => setPlaylistUrl(e.target.value)}
//             />

//             <TextField
//               className={classes.input}
//               label="Add Description for Playlist"
//               value={playlistDescription}
//               onChange={(e) => setPlaylistDescription(e.target.value)}
//             />
//             <Button
//               className={classes.button}
//               variant="contained"
//               onClick={handleUploadPlaylist}
//             >
//               Upload Playlist
//             </Button>

//             <Box className={classes.list}>
//               {videos.map((video) => (
//                 <Box key={video.videoId} className={classes.videoItem}>
//                   <img
//                     src={video.thumbnail}
//                     alt={video.title}
//                     className={classes.thumbnail}
//                   />
//                   <Typography>{video.title}</Typography>
//                 </Box>
//               ))}
//             </Box>

//             <Button className={classes.backBtn} onClick={handleClose}>
//               Back
//             </Button>
//           </Box>
//         </Fade>
//       </Modal>
//     </>
//   );
// }

// export default UploadPlaylistModal;

//  *! after adding category dorpdown and language dropdown

// import React, { useEffect, useState } from "react";
// import Modal from "@mui/material/Modal";
// import Fade from "@mui/material/Fade";
// import Typography from "@mui/material/Typography";
// import Backdrop from "@mui/material/Backdrop";
// import Box from "@mui/material/Box";
// import {
//   TextField,
//   Button,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { API } from "../../backend";
// import { getAllCategoriesUnderParent } from "../../helper/categoryApiCalls/category";

// const style = {
//   width: "100%",
//   maxWidth: "100vw",
//   position: "fixed",
//   top: "50%",
//   left: "0",
//   transform: "translate(0, -50%)",
//   overflowY: "auto",
// };

// const useStyles = makeStyles((theme) => ({
//   input: {
//     width: "100%",
//     margin: "10px 0",
//     outline: "none",
//     color: "var(--text-primary)",
//     "& .MuiOutlinedInput-notchedOutline": {
//       borderColor: "var(--text-primary) !important",
//     },
//     "& .MuiInputLabel-root": {
//       color: "var(--text-primary) !important",
//     },
//     "& .MuiInputBase-input": {
//       color: "var(--text-primary) !important",
//     },
//   },
//   formControl: {
//     margin: "10px 0",
//     "& .MuiOutlinedInput-notchedOutline": {
//       borderColor: "var(--text-primary) !important",
//     },
//     "& .MuiInputLabel-root": {
//       color: "var(--text-primary) !important",
//     },
//     "& .MuiSelect-icon": {
//       color: "var(--text-primary) !important",
//     },
//     "& .MuiSelect-select": {
//       color: "var(--text-primary) !important",
//     },
//   },
//   text: {
//     fontSize: "14px",
//     margin: 2,
//   },
//   menu: {
//     width: "100%",
//   },
//   add: {
//     fontSize: "17px",
//     marginLeft: "10px",
//     fontWeight: "600",
//     backgroundClip: "border-box",
//     background: "-webkit-linear-gradient(#4a1d85, #156fbc)",
//     "-webkit-background-clip": "text",
//     "-webkit-text-fill-color": "transparent",
//     cursor: "pointer",
//     border: "none",
//   },
//   box: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   list: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     overflowY: "scroll",
//     height: "150px",
//     "&::-webkit-scrollbar": {
//       width: "6px",
//     },
//   },
//   links: {
//     fontSize: "14px",
//     display: "block",
//     margin: "10px 0",
//     outline: "none",
//     border: "none",
//     width: "100%",
//     color: "var(--text-primary)",
//     background: "transparent",
//     cursor: "text",
//   },
//   button: {
//     float: "right",
//     margin: "30px",
//     padding: "10px 20px",
//     background: "linear-gradient(92.12deg, #4a1d85 1.79%, #156fbc 99.22%)",
//     color: "white",
//     cursor: "pointer",
//     fontSize: "16px",
//     border: "none",
//   },
//   title: {
//     fontSize: "20px",
//     fontWeight: "600",
//     backgroundClip: "border-box",
//     background: "-webkit-linear-gradient(#4a1d85, #156fbc)",
//     "-webkit-background-clip": "text",
//     "-webkit-text-fill-color": "transparent",
//     border: "none",
//   },
//   error: {
//     color: "red",
//     fontSize: "13px",
//     marginTop: "10px",
//     fontWeight: "600",
//   },
//   success: {
//     color: "green",
//     fontSize: "14px",
//     marginTop: "10px",
//     fontWeight: "600",
//   },
//   linkContainer: {
//     display: "flex",
//     // alignItems: "",
//     width: "100%",
//     justifyContent: "space-between",
//     borderBottom: "1px solid #e6e6e6",
//   },
//   delbtn: {
//     fontSize: "20px",
//     color: "red",
//     fontWeight: "600",
//     border: "none",
//     outline: "none",
//     background: "transparent",
//     cursor: "pointer",
//   },
//   modal: {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: "600px",
//     height: "700px",
//     background: "var(--bg-secondary)",
//     padding: "40px",
//     outline: "none",
//     borderRadius: "10px",
//   },
//   input: {
//     width: "100%",
//     margin: "10px 0",
//   },
//   button: {
//     marginTop: "20px",
//     width: "100%",
//     background: "linear-gradient(92.12deg, #4a1d85 1.79%, #156fbc 99.22%)",
//     color: "#fff",
//   },
//   list: {
//     marginTop: "20px",
//     maxHeight: "250px",
//     overflowY: "scroll",
//     outline: "none",
//     "&:focus": {
//       outline: "1px solid #139ded",
//       borderRadius: "5px",
//     },
//     padding: "10px",
//     border: "0.5px solid var(--text-primary)",
//     borderRadius: "5px",
//     boxShadow: "1px 1px 1px 1px var(--text-secondary)",
//     fontSize: "14px",
//     color: "var(--text-primary)",
//     background: "transparent",
//     lineHeight: "1.5",
//   },
//   videoItem: {
//     display: "flex",
//     alignItems: "center",
//     marginBottom: "10px",
//   },
//   back: {
//     float: "left",
//     margin: "30px 0",
//     padding: "10px 20px",
//     color: "var(--text-primary)",
//     cursor: "pointer",
//     fontSize: "16px",
//     border: "none",
//   },
// }));

// function UploadPlaylistModal({ open, setOpen }) {
//   const classes = useStyles();

//   const [playlistUrl, setPlaylistUrl] = useState("");
//   const [playlistName, setPlaylistName] = useState("");
//   const [playlistDescription, setPlaylistDescription] = useState("");
//   const [videos, setVideos] = useState([]);
//   const [error, setError] = useState("");

//   //  *? new

//   const [categories, setCategories] = React.useState([]);
//   const [branchCategory, setBranchCategory] = React.useState([]);
//   const [selectedBrach, setSelectedBranch] = React.useState([]);
//   const [detailError, setDetailError] = React.useState("");
//   const [language, setLanguage] = React.useState("");

//   const handleClose = () => setOpen(false);

//   const handleUploadPlaylist = async () => {
//     if (!playlistUrl || !playlistName) {
//       setError("Please enter playlist URL and name");
//       return;
//     }
//     if (!selectedBrach.length) {
//       setDetailError("Please select category");
//       return;
//     }
//     if (!language) {
//       setDetailError("Please select language");
//       return;
//     }
//     try {
//       const response = await axios.post(
//         `${API}/playlist/create-from-youtube`,
//         {
//           name: playlistName,
//           playlistLink: playlistUrl,
//           description: playlistDescription,
//           category: selectedBrach,
//           language: language?.toLowerCase(),
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${JSON.parse(
//               localStorage.getItem("_access_token"),
//             )}`,
//           },
//         },
//       );
//       console.log(response?.data?.success);

//       if (response?.data?.success === true) {
//         toast("Playlist uploaded successfully!");
//         setVideos(response?.data?.data || []);
//         setPlaylistUrl("");
//         setPlaylistName("");
//         setPlaylistDescription("");
//         setError("");
//       } else {
//         setError("Failed to upload playlist");
//       }
//     } catch (err) {
//       console.log(err);
//       setError("Error uploading playlist");
//     }
//   };

//   //  *? new
//   useEffect(() => {
//     async function fetchCategories() {
//       const config = {
//         method: "get",
//         url: `${API}/category/getAll`,
//       };

//       const data = await axios(config);
//       setCategories(data.data.data);
//     }

//     fetchCategories();
//   }, []);

//   // *? new , handle cats
//   async function handleCategory(event) {
//     if (event.target.value) {
//       const response = await getAllCategoriesUnderParent(event.target.value);

//       if (response) {
//         let object = {
//           index: 0,
//           subCategories: response.data,
//         };

//         setBranchCategory([object]);
//         setSelectedBranch([event.target.value]);
//       }
//     }
//   }

//   async function handleSubCat(e, index) {
//     if (e.target.value) {
//       const response = await getAllCategoriesUnderParent(e.target.value);

//       if (response && response.data.length > 0) {
//         let newArr = await branchCategory;

//         let object = {
//           index: index + 1,
//           subCategories: response.data,
//         };

//         await newArr.push(object);

//         await setBranchCategory(newArr);
//       }
//       if (selectedBrach.length > 0 && !selectedBrach[index + 1]) {
//         setSelectedBranch((selectedBrach) => [
//           ...selectedBrach,
//           e.target.value,
//         ]);
//       } else {
//         let otherBranch = [...selectedBrach];
//         await otherBranch.splice(index + 1, otherBranch.length - (index + 1));

//         let newOtherBranch = [...otherBranch];
//         await newOtherBranch.push(e.target.value);
//         await setSelectedBranch(newOtherBranch);

//         if ([...branchCategory].length >= newOtherBranch.length) {
//           let newupdatedBranchCat = await [...branchCategory].splice(
//             index + 1,
//             [...branchCategory].length - (index + 1),
//           );

//           let newupdatedArray = await [...branchCategory].filter(
//             (n) => !newupdatedBranchCat.includes(n),
//           );

//           if (response && response.data.length > 0) {
//             let object = {
//               index: index + 1,
//               subCategories: response.data,
//             };
//             await newupdatedArray.push(object);
//             await setBranchCategory(newupdatedArray);
//           } else {
//             await setBranchCategory(newupdatedArray);
//           }
//         }
//       }
//     }
//   }

//   async function handleAdd(e) {
//     e.preventDefault();
//     if (videoName === "") {
//       return;
//     }

//     setVideoList([...videoList, videoName]);

//     let YT_url =
//       "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=";
//     const key = "&key=AIzaSyDIcBfTRXG5W4G4QzzlkBDSN6W9Y3RXjQM";

//     YT_url += videoName.slice(17);

//     // YT_url += "%2C" + vids[i].slice(17);

//     YT_url = (await YT_url) + key;
//     const config = {
//       method: "get",
//       url: YT_url,
//     };

//     const result = await axios(config);

//     let newResult = Object.assign(result?.data?.items[0], {
//       videoName: videoName,
//     });

//     if (result.data.items.length !== 0) {
//       await setDetail((prevArray) => [...prevArray, newResult]);
//     }

//     setVideoName("");
//   }

//   const checkLink = async (link) => {
//     let check;
//     if (videoList.includes(link)) {
//       setError("Video already exists");
//       setVideoName("");
//     } else if (link !== "") {
//       check = await youtube_parser(link);
//       if (check === false) {
//         check = link;
//         setError("Invalid link ");
//         setVideoName("");
//       }
//     } else {
//       setError("");
//     }

//     // return true;
//     // setError("");
//     setVideoName(check);
//   };

//   async function youtube_parser(url) {
//     var regExp =
//       /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
//     var match = await url.match(regExp);
//     return match && match[7].length === 11
//       ? `https://youtu.be/${match[7]}`
//       : false;
//   }

// const removeVideo = (v) => {
//   // e.preventDefault();

//   const newList = videoList.filter((video) => video !== v);

//   let newDetail = detail.filter((video) => video.videoName !== v);

//   setDetail(newDetail);

//   setVideoList(newList);
// };

// // eslint-disable-next-line react-hooks/exhaustive-deps
// useEffect(async () => {
//   var config = {
//     method: "get",
//     url: `${API}/category/getAll`,
//     headers: {},
//   };

//   const data = await axios(config);

//   setCategories(data.data.data);
// }, []);

// const UploadList = () => {
//   if (videoList.length < 5) {
//     setDetailError("Please add atleast 5 videos");
//     return;
//   } else if (desc.name < 3 || desc.description < 8 || desc.language < 3) {
//     setDetailError("Name or Description or Language not long enough");
//     return;
//   }

//   if (detail && detail.length > 0) {
//     let videoDeatils = [];

//     for (let i = 0; i < detail.length; i++) {
//       let object = {
//         videoName: detail[i].videoName,
//         title: detail[i].snippet.title,
//         description: detail[i].snippet.description,
//         thumbnail: detail[i].snippet.thumbnails.high.url,
//         publishedAt: detail[i].snippet.publishedAt,
//         language: desc.language,
//       };
//       videoDeatils.push(object);
//     }

//     var data = {
//       name: desc.name,
//       description: desc.description,
//       language: desc.language,
//       category: selectedBrach,

//       videos: videoDeatils,
//     };

//     var config = {
//       method: "post",
//       url: `${API}/playlist/create`,
//       headers: {
//         Authorization: `Bearer ${JSON.parse(
//           localStorage.getItem("_access_token"),
//         )}`,
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios(config)
//       .then(function (response) {
//         if (response?.data?.status === "success") {
//           setSuccess(true);
//           toast("Playlist Uploaded Successfully");
//         }

//         // setOpen(false);

//         setTimeout(() => {
//           window.location.reload();
//         }, 2000);
//       })
//       .catch(function (error) {
//         console.log(error);
//       });
//   }
// };

// //  *? language dropdown
// const languages = [
//   "English",
//   "Hindi",
//   "Marathi",
//   "Konkani",
//   "Bengali",
//   "Tamil",
//   "Kannada",
//   "German",
//   "Chinese",
//   "Telugu",
// ];

// async function handleSubCat(e, index) {
//   if (e.target.value) {
//     const response = await getAllCategoriesUnderParent(e.target.value);

//     let updatedBranch = [...selectedBrach];
//     updatedBranch[index + 1] = e.target.value;
//     updatedBranch = updatedBranch.slice(0, index + 2);

//     setSelectedBranch(updatedBranch);

//     let updatedCategories = branchCategory.slice(0, index + 1);

//     if (response?.data?.length > 0) {
//       updatedCategories.push({
//         index: index + 1,
//         subCategories: response.data,
//       });
//     }

//     setBranchCategory(updatedCategories);
//   }
// }

// return (
//   <>
//     <ToastContainer />
//     <Modal
//       open={open}
//       onClose={handleClose}
//       closeAfterTransition
//       BackdropComponent={Backdrop}
//       BackdropProps={{ timeout: 500 }}
//     >
//       <Fade in={open}>
//         <Box className={classes.modal}>
//           <Typography variant="h6" sx={{ mb: 2 }}>
//             Upload YouTube Playlist
//           </Typography>

//           {error && (
//             <Typography sx={{ color: "red", mb: 1 }}>* {error}</Typography>
//           )}

//           <TextField
//             className={classes.input}
//             label="Topic"
//             value={playlistName}
//             onChange={(e) => setPlaylistName(e.target.value)}
//           />

//           <TextField
//             className={classes.input}
//             label=" Description  "
//             value={playlistDescription}
//             onChange={(e) => setPlaylistDescription(e.target.value)}
//           />
//           {/*  language dropdown */}
//           <FormControl
//             fullWidth
//             className={classes.formControl}
//             sx={{ my: 2 }}
//           >
//             <InputLabel>Language</InputLabel>
//             <Select
//               value={language}
//               label="Language"
//               onChange={(e) => setLanguage(e.target.value)}
//             >
//               {languages.map((lang) => (
//                 <MenuItem key={lang} value={lang.toLowerCase()}>
//                   {lang}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {/*  *! category dropdown  */}
//           <FormControl
//             fullWidth
//             sx={{ my: 2 }}
//             className={classes.formControl}
//           >
//             <InputLabel id="demo-simple-select-label">Category</InputLabel>
//             <Select
//               value={selectedBrach[0]}
//               label="Category"
//               onChange={handleCategory}
//             >
//               {categories.map((cat) => (
//                 <MenuItem key={cat._id} value={cat._id}>
//                   {cat.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {branchCategory.map((bra, index) => (
//             <FormControl
//               key={index}
//               fullWidth
//               sx={{ my: 2 }}
//               className={classes.formControl}
//             >
//               <InputLabel>Sub-Category {index + 1}</InputLabel>
//               <Select
//                 value={selectedBrach[index + 1]}
//                 label={`Sub-Category ${index + 1}`}
//                 onChange={(e) => handleSubCat(e, index)}
//               >
//                 {bra.subCategories.map((cat) => (
//                   <MenuItem key={cat._id} value={cat._id}>
//                     {cat.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           ))}

//           {/*  url */}
//           <TextField
//             className={classes.input}
//             label="YouTube Playlist URL"
//             value={playlistUrl}
//             onChange={(e) => setPlaylistUrl(e.target.value)}
//           />

//           {/* <Button
//             className={classes.button}
//             variant="contained"
//             onClick={handleUploadPlaylist}
//           >
//             Upload Playlist
//           </Button> */}

//           {/*  upload & back btn */}
//           {detailError && (
//             <Typography className={classes.error}>* {detailError}</Typography>
//           )}

//           {/*  buttons */}
//           {/* <div className="border border-red-500 flex justify-center w-full items-center">
//             <button
//               className={`${classes.back} w-4/12`}
//               onClick={() => setOpen(false)}
//             >
//               Back
//             </button>
//             <button
//               className={`${classes.button} w-2/12`}
//               onClick={handleUploadPlaylist}
//             >
//               Upload
//             </button>
//             </div> */}
//             <div className=" w-full flex items-center justify-between my-4 px-6">
//               <div>
//                 <button
//                   className={`${classes.back} !m-0`}
//                   onClick={() => setOpen(false)}
//                 >
//                   Back
//                 </button>
//               </div>

//               <div>
//                 <button
//                   className={`${classes.button} !m-0 !px-4 !py-2`}
//                   onClick={handleUploadPlaylist}
//                 >
//                   Upload
//                 </button>
//               </div>
//             </div>

//             <Box className={classes.list}>
//               {videos.map((video) => (
//                 <Box key={video.videoId} className={classes.videoItem}>
//                   <img
//                     src={video.thumbnail}
//                     alt={video.title}
//                     className={classes.thumbnail}
//                   />
//                   <Typography>{video.title}</Typography>
//                 </Box>
//               ))}
//             </Box>

//             {/* <Button className={classes.backBtn} onClick={handleClose}>
//               Back
//             </Button> */}
//           </Box>
//         </Fade>
//       </Modal>
//     </>
//   );
// }

// export default UploadPlaylistModal;

//  *! after merge conflict , the code is this
import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API } from "../../backend";
import { getAllCategoriesUnderParent } from "../../helper/categoryApiCalls/category";

const useStyles = makeStyles(() => ({
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxHeight: "80vh",
    overflowY: "auto",
    background: "var(--bg-secondary)",
    padding: "30px",
    outline: "none",
    borderRadius: "10px",

    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--text-secondary)",
      borderRadius: "4px",
    },
  },

  input: {
    width: "100%",
    margin: "10px 0",
    color: "var(--text-primary)",

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--text-primary)",
    },
    "& .MuiInputLabel-root": {
      color: "var(--text-primary)",
    },
    "& .MuiInputBase-input": {
      color: "var(--text-primary)",
    },
  },

  formControl: {
    margin: "10px 0",

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--text-primary)",
    },
    "& .MuiInputLabel-root": {
      color: "var(--text-primary)",
    },
    "& .MuiSelect-select": {
      color: "var(--text-primary)",
    },
    "& .MuiSelect-icon": {
      color: "var(--text-primary)",
    },
  },

  button: {
    background: "linear-gradient(92.12deg, #4a1d85 1.79%, #156fbc 99.22%)",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    padding: "10px 18px",
    fontSize: "15px",
    borderRadius: "6px",
  },

  back: {
    background: "transparent",
    color: "var(--text-primary)",
    border: "none",
    cursor: "pointer",
    fontSize: "15px",
  },

  error: {
    color: "red",
    fontSize: "13px",
    marginTop: "8px",
    fontWeight: 600,
  },

  list: {
    marginTop: "20px",
    maxHeight: "250px",
    overflowY: "auto",
  },

  videoItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },

  thumbnail: {
    width: "120px",
    height: "90px",
    marginRight: "10px",
    borderRadius: "6px",
  },
}));

function UploadPlaylistModal({ open, setOpen }) {
  const classes = useStyles();

  const [playlistUrl, setPlaylistUrl] = useState("");
  const [playlistName, setPlaylistName] = useState("");
  const [playlistDescription, setPlaylistDescription] = useState("");
  const [videos, setVideos] = useState([]);
  const [error, setError] = useState("");

  const [categories, setCategories] = useState([]);
  const [branchCategory, setBranchCategory] = useState([]);
  const [selectedBrach, setSelectedBranch] = useState([]);
  const [detailError, setDetailError] = useState("");
  const [language, setLanguage] = useState("");

  const handleClose = () => setOpen(false);

  const handleUploadPlaylist = async () => {
    if (!playlistUrl || !playlistName) {
      setError("Please enter playlist URL and name");
      return;
    }
    if (!selectedBrach.length) {
      setDetailError("Please select category");
      return;
    }
    if (!language) {
      setDetailError("Please select language");
      return;
    }

    try {
      const response = await axios.post(
        `${API}/playlist/create-from-youtube`,
        {
          name: playlistName,
          playlistLink: playlistUrl,
          description: playlistDescription,
          category: selectedBrach,
          language: language,
        },
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("_access_token"),
            )}`,
          },
        },
      );

      if (response?.data?.success) {
        toast("Playlist uploaded successfully!");
        setVideos(response?.data?.data || []);
        setPlaylistUrl("");
        setPlaylistName("");
        setPlaylistDescription("");
        setError("");
      }
    } catch {
      setError("Error uploading playlist");
    }
  };

  useEffect(() => {
    axios.get(`${API}/category/getAll`).then((res) => {
      setCategories(res.data.data);
    });
  }, []);

  const languages = [
    "English",
    "Hindi",
    "Marathi",
    "Konkani",
    "Bengali",
    "Tamil",
    "Kannada",
    "German",
    "Chinese",
    "Telugu",
  ];

  async function handleCategory(e) {
    const response = await getAllCategoriesUnderParent(e.target.value);
    setSelectedBranch([e.target.value]);
    setBranchCategory([{ index: 0, subCategories: response?.data || [] }]);
  }

  async function handleSubCat(e, index) {
    const response = await getAllCategoriesUnderParent(e.target.value);

    const updatedBranch = [...selectedBrach];
    updatedBranch[index + 1] = e.target.value;
    setSelectedBranch(updatedBranch.slice(0, index + 2));

    const updatedCats = branchCategory.slice(0, index + 1);
    if (response?.data?.length) {
      updatedCats.push({
        index: index + 1,
        subCategories: response.data,
      });
    }
    setBranchCategory(updatedCats);
  }

  return (
    <>
      <ToastContainer />
      <Modal open={open} onClose={handleClose} BackdropComponent={Backdrop}>
        <Fade in={open}>
          <Box className={classes.modal}>
            <Typography variant="h6">Upload YouTube Playlist</Typography>

            {error && (
              <Typography className={classes.error}>* {error}</Typography>
            )}

            <TextField
              className={classes.input}
              sx={{ my: 2 }}
              label="Topic"
              value={playlistName}
              onChange={(e) => setPlaylistName(e.target.value)}
            />

            <TextField
              className={classes.input}
              label="Description"
              value={playlistDescription}
              onChange={(e) => setPlaylistDescription(e.target.value)}
            />

            <FormControl
              sx={{ my: 2 }}
              fullWidth
              className={classes.formControl}
            >
              <InputLabel>Language</InputLabel>
              <Select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
              >
                {languages.map((l) => (
                  <MenuItem key={l} value={l.toLowerCase()}>
                    {l}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              sx={{ my: 2 }}
              fullWidth
              className={classes.formControl}
            >
              <InputLabel>Category</InputLabel>
              <Select value={selectedBrach[0]} onChange={handleCategory}>
                {categories.map((cat) => (
                  <MenuItem key={cat._id} value={cat._id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {branchCategory.map((bra, index) => (
              <FormControl
                key={index}
                fullWidth
                sx={{ my: 2 }}
                className={classes.formControl}
              >
                <InputLabel>Sub-Category {index + 1}</InputLabel>
                <Select
                  value={selectedBrach[index + 1]}
                  onChange={(e) => handleSubCat(e, index)}
                >
                  {bra.subCategories.map((cat) => (
                    <MenuItem key={cat._id} value={cat._id}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ))}

            {detailError && (
              <Typography className={classes.error}>* {detailError}</Typography>
            )}

            <TextField
              className={classes.input}
              label="YouTube Playlist URL"
              value={playlistUrl}
              onChange={(e) => setPlaylistUrl(e.target.value)}
            />

            <div className="flex justify-between mt-4">
              <button className={classes.back} onClick={handleClose}>
                Back
              </button>
              <button className={classes.button} onClick={handleUploadPlaylist}>
                Upload
              </button>
            </div>

            <Box className={classes.list}>
              {videos.map((v) => (
                <Box key={v.videoId} className={classes.videoItem}>
                  <img src={v.thumbnail} className={classes.thumbnail} />
                  <Typography>{v.title}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default UploadPlaylistModal;
